import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import { referralsQueryOptions } from "../../../../features/referrals/queries"

const referralsSearchSchema = z.object({
    search: z.coerce.string().optional().catch(""),
    page: z.coerce.number().catch(1),
    facility: z.coerce.number().optional().catch(undefined),
})

export const Route = createFileRoute("/_app/manage/referrals/")({
    validateSearch: (search: SearchSchemaInput) => referralsSearchSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: ({ context, deps }) => {
        if (deps.facility) {
            return context.queryClient.ensureQueryData(
                referralsQueryOptions({ params: { query: deps } })
            )
        }
        return null
    },
}) 